import Navigation from "@/components/Navigation";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import heroBackground from "@/assets/services-background.webp";
import PrimaryCTA from "@/components/PrimaryCTA";
import Footer from "@/components/Footer";

const Services = () => {
  const services = [
    {
      title: "Cloud & Infrastructure",
      description:
        "Seamless transition to Cloud and hybrid environments with cost control and performance tuning. We aim for zero downtime migrations and optimize your cloud spend. Design and integrate tailor made IT infrastructure protecting flow, availability, and integrity.",
    },
    {
      title: "Modern Workplace",
      description:
        "Empower your employees to stay connected and work productively regardless of location and device. We provide and manage the tech your team needs to do their job adopting modern tools.",
    },
    {
      title: "Managed IT Services",
      description:
        "Stay focused on your business while we take care of your IT. Our Managed IT Services cover everything from proactive monitoring and patching to full support for hybrid infrastructures. Every engagement is backed by a tailored service agreement with clear SLAs so you always know what’s included, how quickly issues will be resolved, and what it will cost.",
    },
    {
      title: "Compliance & Security",
      description:
        "Protect your business with enterprise‑grade security and compliance frameworks. We help you align with international standards such as ISAE‑3000, ISAE‑3402, and ISO 27001 ensuring data integrity, confidentiality, and regulatory compliance across your IT landscape.",
    },
    {
      title: "Backup, Contingency & Disaster Recovery",
      description:
        "Keep your business running no matter what happens. We design and implement backup and disaster recovery strategies that protect your data, minimize downtime, and ensure continuity in the face of unexpected events.",
    },
    {
      title: "Digital Transformation Strategy",
      description:
        "Roadmaps, assessments, and change management to help your business evolve securely and efficiently.",
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Navigation />

      {/* Hero Section */}
      <section
        className="relative w-full px-4 py-20 md:py-32 overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${heroBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "50% 67%", // keeps more of the top visible
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <h1 className="mt-16 text-4xl md:text-6xl font-bold mb-6 text-white">
            Our Services
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-2xl mx-auto">
            Comprehensive IT solutions tailored for enterprises in Denmark and the Nordics
          </p>
          <PrimaryCTA />
        </div>
      </section>

      <main className="container mx-auto px-4 py-16">
        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {services.map((service, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <CardTitle>{service.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-base">
                  {service.description}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center py-16 bg-muted rounded-lg mb-20">
          <h2 className="text-3xl font-bold mb-4">
            Ready to Transform Your IT Infrastructure?
          </h2>
          <p className="text-muted-foreground mb-6">
            Let's discuss how we can help your business scale securely and efficiently
          </p>
          <PrimaryCTA />
        </div>

        {/* Trusted By Section */}
        <section className="py-12">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold mb-2">Trusted By</h2>
            <p className="text-muted-foreground">
              Leading enterprises across industries
            </p>
          </div>
          <ul className="max-w-xl mx-auto text-lg text-muted-foreground space-y-3 list-disc list-inside">
            <li>Financial Services</li>
            <li>Healthcare & Life Sciences</li>
            <li>Retail & E-Commerce</li>
            <li>Manufacturing & Logistics</li>
            <li>Education & Government</li>
            <li>Insurance</li>
          </ul>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Services;
